import { takeEvery, put } from "redux-saga/effects";
import { request } from '../../../api/Service';
import { getErrorMessage } from '../../../components/utils/errorHandler';
import { toast } from 'react-toastify';
import history from '../../../router/browserrouter';
import {store} from "../../store";
export default function* watcherAddInventoryCorrectionSaga() {
    yield takeEvery("ADD_INVENTORY_CORRECTION", workerSaga);
}

function* workerSaga(action) {
    try 
    {
        yield put({ type: "DISPLAY_LOADER" });
        let payload = {};
       var url='inventory-correction'
       yield request("post", action.payload, url).then(response => {
            payload = response;
        });
        toast.success(payload)
        var formatUrl = 'api/Admin/get-user-location-dropdown?userId='+store.getState().persistReducer.userId;
    
        yield request("get", {}, formatUrl).then(response => {
            payload = response;
        });
        console.log(payload)
        yield put({ type: "LOCATIONS_LIST_DROPDOWN", payload: payload })

        formatUrl = 'api/Admin/get-product-dropdown?id=' + store.getState().persistReducer.companyId;
        yield request("get", {}, formatUrl).then(response => {
            payload = response;
        });
        console.log(payload)
        yield put({ type: "PRODUCT_DROPDOWN_LIST", payload: payload })
        formatUrl = 'get-inventory/'
        yield request("get", {}, formatUrl).then(response => {
            payload = response;
        });
        console.log(payload)
        yield put({ type: "INVENTORIES_LIST", payload: payload })
        yield put({ type: "DISPLAY_LOADER"})
    } catch (e) {
        yield put({ type: "LOADING_BUTTON_SPINNER" });
        console.log("add-product-saga",e)
        yield put({ type: "DISPLAY_LOADER" });
        console.log("add-product-saga",e.response)
        console.log(e.response)
        const errorMessage = getErrorMessage(e.response);
        toast.error(errorMessage);
        yield put({ type: "API_ERRORED", payload: e });
    }
}
